import { Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import { EeReport, EeReportSpecificPowerMoney } from "@/shared/modules/typescript-trustapi-client/models";
import { FormEERData } from "@/trust-atcs-app/models/form-eer-data";
import RadioButtonSubQuestions from "../questions/radiobutton-subquestions/index.vue";

@Options({
  components: {
    LoadingSpinner,
    RadioButtonHorizontal,
    RadioButtonVertical,
    RadioButtonSubQuestions
  },
  emits: ['update:isSectionLoading', 'validForm'],
  mixins: [FormatDateTimeMixin],
})
export default class FormEerSpecificPowerMoney extends Vue {

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop({ default: {} })
  private formEERData!: FormEERData;

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private errorLoadingContent = false;

  private validMainQuestions: boolean[] = [];
  private specificPowerMoney: EeReportSpecificPowerMoney = null as any;

  mounted(): void {
    this.eventCtrl.on('reload-form-eer-spm-content', this.loadSpecificPowerMoneyContent);
    // this.loadingContent = true;
    this.loadSpecificPowerMoneyContent();
    this.$emit('validForm', false);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-eer-spm-content', this.loadSpecificPowerMoneyContent);
  }

  private async loadSpecificPowerMoneyContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.EeReportApi?.apiV2EeReportGetSpecificPowerMoneyPost({
        complianceFormId: this.complianceFormEER.id,
        updatingKey: this.updatingKey,
      });
      this.specificPowerMoney = resp.data.data as EeReportSpecificPowerMoney;
      this.formEERData.specificPowerMoney = this.specificPowerMoney as any;
      // Sort atcsMainQuestions by order number
      this.formEERData.specificPowerMoney.atcsMainQuestions = this.formEERData.specificPowerMoney.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formEERData.specificPowerMoney.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      // Sort response by order number
      this.formEERData.specificPowerMoney.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });

      this.validMainQuestions = this.formEERData.specificPowerMoney.atcsMainQuestions.map((q: any) => false);
      // set atcsMainQuestions.questionTypeId == 1 to true
      this.formEERData.specificPowerMoney.atcsMainQuestions.forEach((q: any, i: number) => {
        if (q.atcsQuestionTypeId == 1) {
          this.validMainQuestions[i] = true;
        }
      });

      // add valid flag to each bank account
      // this.formEERData.controlledMoney.atcsMainQuestions.forEach((q: any, i: number) => {

      // if (q.atcsQuestionTypeId == 19) {
      //   this.formEERData.controlledMoney.atcsMainQuestions[i].formPracticeAccountQuestions =
      //     this.formEERData.controlledMoney.atcsMainQuestions[i].formPracticeAccountQuestions ?? [];
      // }

      // if (q.atcsQuestionTypeId == 20) {
      //   this.formEERData.controlledMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions =
      //     this.formEERData.controlledMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions ?? [];
      // }

      // if (q.formPracticeAccountQuestions) {
      //   q.formPracticeAccountQuestions.forEach((b: any) => {
      //     b.valid = this.isValidBankAccount(b);
      //   });
      // }
      // });

      // // add valid flag to each signatory
      // this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any) => {
      //   if (q.formPracticeSignatoryQuestions) {
      //     q.formPracticeSignatoryQuestions.forEach((s: any) => {
      //       s.valid = this.isValidSignatory(s);
      //     });
      //   }
      // });
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Specific Power Money');
      this.ai.trackException('Error getting Specific Power Money: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    const allTrue = Object.values(this.validMainQuestions).every(value => value === true);
    return allTrue;
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get complianceFormEER(): EeReport {
    return store.getters.getSelectedComplianceFormEER;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

}
